module.exports = __webpack_public_path__ + "img/Stockholm-Men.ece1d052.jpg";